module.exports = __webpack_public_path__ + "img/WS.89588991.svg";